import { DefaultTheme } from 'styled-components';

const light: DefaultTheme = {
  title: 'light',

  colors: {
    primary: '#0C56C4',
    secondary: '#fff',
  },

  background: {
    primary: '#fff',
  },
};

export { light };
